export default "__VITE_ASSET__7d75d6d3__"